"use client";

import * as React from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "next-themes";
import { Menu, Transition } from '@headlessui/react';

export function ThemeToggle() {
    const { theme, setTheme } = useTheme();
    const [mounted, setMounted] = React.useState(false);

    React.useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return <div className="p-2 w-10 h-10" />;
    }

    const themes = [
        { name: 'light', label: '明亮 Light', icon: <Sun size={14} /> },
        { name: 'dark', label: '暗黑 Dark', icon: <Moon size={14} /> },
        { name: 'system', label: '跟随 System', icon: <Monitor size={14} /> },
    ];

    return (
        <Menu as="div" className="relative inline-block text-left">
            {({ open }) => (
                <>
                    <Menu.Button
                        className={`w-10 h-10 rounded-none flex items-center justify-center transition-all duration-300 border
                            ${open
                                ? 'bg-blue-600 border-blue-500 text-white'
                                : 'bg-zinc-100 dark:bg-zinc-800/50 hover:bg-zinc-200 dark:hover:bg-zinc-700/50 text-zinc-500 dark:text-zinc-400 border-zinc-200 dark:border-zinc-700/50'
                            }`}
                        title="切换主题"
                    >
                        {theme === "light" && <Sun size={18} className="animate-in zoom-in duration-300" />}
                        {theme === "dark" && <Moon size={18} className="animate-in zoom-in duration-300" />}
                        {theme === "system" && <Monitor size={18} className="animate-in zoom-in duration-300" />}
                    </Menu.Button>

                    <Transition
                        as={React.Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Menu.Items className="absolute right-0 mt-2 w-44 bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-none p-2 z-200 focus:outline-none">
                            <div className="flex flex-col gap-1">
                                {themes.map((t) => (
                                    <Menu.Item key={t.name}>
                                        {({ active }) => (
                                            <button
                                                onClick={() => setTheme(t.name)}
                                                className={`flex items-center gap-3 px-3 py-2.5 rounded-none text-xs font-bold transition-all w-full
                                                    ${active || theme === t.name
                                                        ? 'bg-blue-50 dark:bg-blue-600/20 text-blue-600 dark:text-blue-400'
                                                        : 'text-zinc-500 dark:text-zinc-400'
                                                    }`}
                                            >
                                                <span className={theme === t.name ? 'text-blue-500' : 'text-zinc-400'}>{t.icon}</span>
                                                {t.label}
                                            </button>
                                        )}
                                    </Menu.Item>
                                ))}
                            </div>
                            <div className="mt-2 pt-2 border-t border-zinc-100 dark:border-zinc-800">
                                <p className="text-[9px] text-zinc-400 px-3 uppercase tracking-widest font-black text-center">Appearance Settings</p>
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    );
}
